import { withTrackedReducer } from '@angular-architects/ngrx-toolkit';
import { initialEngineReportsState } from '@navstation-portal/reporting/data-model/engine-reports';
import { signalStoreFeature } from '@ngrx/signals';
import { on } from '@ngrx/signals/events';
import { engineReportsEvents } from './engine-reports-events';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function withEngineReportsReducer<_>() {
  return signalStoreFeature(
    withTrackedReducer(
      on(engineReportsEvents.fetchedEngineReports, ({ payload }) => ({
        meReports: payload.meReports,
        aeReports: payload.aeReports,
      })),
      on(engineReportsEvents.extractEngineReports, () => ({
        isExtracting: true,
      })),
      on(engineReportsEvents.extractEngineReportsSuccess, () => ({
        isExtracting: false,
      })),
      on(engineReportsEvents.extractEngineReportsFailed, () => ({
        isExtracting: false,
      })),
      on(engineReportsEvents.reset, () => initialEngineReportsState)
    )
  );
}
